import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const MainWrapper = (): ReactElement => <Outlet />;

export default MainWrapper;
